/**
 * 表格列配置
 */

import { updateColsConfig } from "@/components/ColsTable/service"

const tableCols = {
    state: () => {
        return {
            // 以pageId作为key
            // 以列配置作为值
            colsMap: {}
        }
    },
    mutations: {
        setColsMap (state, colsMap) {
            state.colsMap = colsMap
        },
        updateCols(state, {pageId, newCols}) {
            let newColsMap = {
                ...state.colsMap
            }

            newColsMap[pageId] = newCols
            state.colsMap = newColsMap
        },
        updateColsWidth(state, {pageId, col}) {
            let newColsMap = {
                ...state.colsMap
            }
            let pageCols = newColsMap[pageId] || []
            let oldCol = pageCols.find(({field}) => field === col.field);
            if (!oldCol) return false;
            oldCol.width = col.width;
            state.colsMap = newColsMap;
            return pageCols;
        }
    },
    actions: {
        clearTableColsConfig({commit}) {
            commit('setColsMap', {})
        },
        updateTableColsConfig({commit}, {pageId, newCols} = {}) {
            commit('updateCols', {pageId, newCols})
        },
        updateTableColsWidthByDrag({commit, state}, {pageId, col} = {}) {
            commit('updateColsWidth', {pageId, col});
            let newCols = state.colsMap[pageId] || [];
            if (!newCols.length) return;
            updateColsConfig({
                pageId: pageId,
                list: newCols
            }, { isNeedLoading: false })
        }
    },
    getters: {
        tableColsConfig(state) {
            return (pageId) => {
                return !!pageId ? state.colsMap[pageId] : false
            }
        }
    }
}

export default tableCols;
